 /*
 Author: Bhushan Tipre
 Date: 21/01/2021
 */

<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <!-- <tl-header type="h3" class="margintop-20">Hold, Stop or Release Salary</tl-header>
    <div class="radio margin-t-m">
      <tl-radio
        name="salary"
        label="Manual"
        id="salary1"
        value="manually"
        v-model="salaryupdate"
        @change="(bool)=>changecheckbox(bool)"
      />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <tl-radio name="salary" label="Bulk Upload" id="salary2" value="bulk" v-model="salaryupdate" />
    </div>
    <div v-if="salaryupdate=='manually'">
      <div class="filters margin-t-m">
        <tl-select
          class="custom-width"
          label="Paygroup"
          labelText="name"
          :placeholder="'Select'"
          :multiple="true"
          :options="paygroupOptions"
          v-model="formData.paygroup"
          @change="(val)=>formData.paygroup=val"
        ></tl-select>
        <tl-select
          class="custom-width"
          label="Criteria"
          labelText="name"
          :placeholder="'Select'"
          :options="criteriaList"
          v-model="formData.criteria"
          @change="(val)=>{ formData.criteria = val;subCriteriaLabel=val.name;getSubCriteria(val)}"
        ></tl-select>
        <tl-select
          v-if="subCriteriaLabel"
          class="custom-width"
          :label="subCriteriaLabel"
          labelText="name"
          :placeholder="'Select'"
          :multiple="true"
          :options="subCriteriaList"
          v-model="formData.subCriteria"
          @change="(val)=>{formData.subCriteria=val}"
        ></tl-select>
        <tl-select
          class="custom-width"
          label="Salary Status"
          labelText="name"
          :placeholder="'Select'"
          :options="salary_status_List"
          @change="(val) => setStatusValue(val)"
        ></tl-select>
        <btn class="margin-15" text="Apply filter" type="secondary" @click="getEmployees()" />
      </div>
      <tl-search @change="filterData($event)" :placeholder="'Search Employee Name'" class="margin-tb-m"/>
      <div class="margin-bottom-100">
        <data-table
          :columns="holdReleaseColumnNames"
          :tableData="employeeData"
          :checkbox="true"
          :withForm="false"
          :showinrow="false"
          :search="searchText"
        >
          <template v-slot:rowcontent="slotprops">
            <p
              v-if="slotprops.value.column.key!='action'"
            >{{slotprops.value.record[slotprops.value.column.key]}}</p>
            <div class="action-section" v-if="slotprops.value.column.key=='action'">
              <img class="menu-icon" src="@/assets/group-2.png" alt="actionIcon" />
              <ul class="action-menu">
                <li
                  :class="{'disabled':slotprops.value.record['salaryStatus'] !== 'Active'}"
                  @click="gotoRelease(slotprops.value.record,'hold')"
                >
                  <span class>Hold Salary</span>
                </li>
                <li
                  :class="{'disabled':slotprops.value.record['salaryStatus'] == 'Active'}"
                  @click="gotoRelease(slotprops.value.record,'release')"
                >
                  <span class>Release Salary</span>
                </li>
                <li
                  :class="{'disabled':slotprops.value.record['salaryStatus'] !== 'Active'}"
                  @click="gotoRelease(slotprops.value.record,'stop')"
                >
                  <span class>Stop Salary</span>
                </li>
              </ul>
            </div>
          </template>
        </data-table>
      </div>
    </div>
    <div v-else>
      <div class="bulkUploadClass">
        <div class="download-btn">
          <download-button onclick></download-button>
        </div>
        <div class="margin-t-15px">
          <upload-file @uploadTemplate="onUploadTemplate($event)" />
        </div>
      </div>

      <pop-up-message
        v-if="showSuccessMsg"
        :message="`File has been submitted successfully.`"
        btnText="Back To Hold, Release and Stop Salary"
        @back="goBackToLocationPage"
      />
    </div>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="cancel" />
          <btn text="Submit" v-if="salaryupdate !='manually'" type="primary" @click="release" />
        </btn-grp>
      </template>
    </bottom-action-container> -->
  
   <!-- Pl-23 code start -->
   <div class="margintop-32">
    <tl-tabs :tabs="tabs">
        <tl-tab>
          <hold-salary></hold-salary>      
        </tl-tab>
        <tl-tab>
          <stop-salary></stop-salary>
        </tl-tab>
        <tl-tab>
          <active-salary></active-salary>
        </tl-tab>
    </tl-tabs>
   </div>
   <!-- End here -->
  </div>
</template>

<script>
import Upload from "@/components/Upload.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import * as constants from "@/apis/constants.js";
import holdSalary from "./holdSalary.vue";
import stopSalary from "./stopSalary.vue";
import activeSalary from "./activeSalary.vue";


export default {
  name: "holdReleaseSalary",
  components: {
    Upload,
    holdSalary,
    stopSalary,
    activeSalary
  },

  data() {
    return {
      tabs: [
        {
          header: "On Hold",
        },
        {
          header: "Stopped",
        },
        {
          header: "Active",
        },
      ],
      criteriaList: [],
      salaryupdate: "manually",
      paygroupOptions: [],
      subCriteriaList: [],
      subCriteriaLabel:"",
      formData: {
        paygroup: "",
        subCriteria: "",
        criteria: "",
        status: "all"
      },
      showSuccessMsg: false,
      salary_status_List: [],
      holdReleaseColumnNames: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Email ID",
          key: "email_id"
        },
        {
          label: "Status",
          key: "salaryStatus"
        },
        {
          label: "Effective Date",
          key: "effectiveDate"
        },
        {
          label: "",
          key: "action"
        }
      ],
      searchText: "",
      employeeData: [],
      activeList: [],
      releaseList: [],
      holdList: [],
      stopList: [],
      date: "",
      monthList: constants.monthOptionsObj.onlyMonths,
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        },
        {
          name: "Hold, Stop or Release Salary",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/hold_release_salary`
        }
      ]
    };
  },
  activated() {
    this.setConstantsData();
    this.fetchPaygroups();
    this.getEmployees();
    this.getEmployeeStatus();
    
  },
  mounted(){
        this.getEmployeeStatus();
        
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      heldemp: state => state.dashboard.payroll.utilities.holdsalary
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods: {
    ...mapActions({
      hold: "dashboard/payroll/utilities/holdsalary/hold",
      getAll: "dashboard/payroll/utilities/holdsalary/fetchAll",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_bunits: "onboard/business_units/fetchAll",
      fetch_costcentre: "onboard/cost_centres/fetchAll",
      fetch_loc: "onboard/locations/fetchAll",
      act_changeEditMode:
        "dashboard/payroll/utilities/holdsalary/changeEditMode",
      fetch_status_list:"dashboard/payroll/utilities/holdsalary/getStatusList",  
      fetch_employee_status: "dashboard/payroll/utilities/holdsalary/getEmployeeByIDStatus",
    }),

    /* function to set default configuration */
    setConstantsData() {
      try {
        this.criteriaList = constants.HoldStopReleaseSalary.criteriaList;
        this.salary_status_List =
          constants.HoldStopReleaseSalary.salaryStatusList;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set status */
    // 'On Hold','Stopped'
    setStatusValue(val) {
      try {
        if (val == "On Hold") {
          this.formData.status = "hold_salary";
        } else if (val == "Stopped") {
          this.formData.status = "stop_salary";
        } else if (val == "Normal") {
          this.formData.status = "normal";
        } else {
          this.formData.status = "all";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get paygroups */
    async fetchPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.le_id);
        if (res.data.status) {
          this.paygroupOptions = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

      // store res obj in local obj or array and seperate data as per employee status
      // store data in three seperate array 
      // send that data to child or tab according status
    async getEmployeeStatus(){

      try{
          let res = await this.fetch_status_list(this.le_id)
          this.activeList = res.data.payload.data.active;
          //console.log("Active member", this.activeList);
          //releaseList = res.payload.data.release;
          this.holdList = res.data.payload.data.hold;
          this.stopList = res.payload.data.stop;
          //console.log("looking for what is coming",res);

      }catch(err){
        //console.log(err);
      }
    },
    
    async getEmployeeStatusPer(){

      try{
          let res = await this.fetch_employee_status(this.employee_id)

          //console.log("looking employee status",res);

      }catch(err){
        //console.log(err);
      }
    },
    
    /* server call to get employees based on selected filter optons */
    async getEmployees() {
      try {
        let obj = {
          legal_entity_id: this.le_id,
          paygroups: this.formData.paygroup
            ? this.formData.paygroup.map(item => {
                return item.id;
              })
            : [],
          bands:
            this.formData.criteria == "Bands"
              ? this.formData.subCriteria.map(item => {
                  return item.id;
                })
              : [],
          bunits:
            this.formData.criteria == "Business Unit"
              ? this.formData.subCriteria.map(item => {
                  return item.id;
                })
              : [],
          locs:
            this.formData.criteria == "Locations"
              ? this.formData.subCriteria.map(item => {
                  return item.id;
                })
              : [],
          cost_centers:
            this.formData.criteria == "Cost Centre"
              ? this.formData.subCriteria.map(item => {
                  return item.id;
                })
              : [],
          salary_status: this.formData.status
        };
        let res = await this.getAll({ ...obj });
        this.employeeData = res.data.payload.data;
        if (this.employeeData.length) {
          for (let employee of this.employeeData) {
            employee["salaryStatus"] = employee.EmployeeSalaryInstructions
              .length
              ? this.getStatus(employee.EmployeeSalaryInstructions)
              : "Active";
            employee["effectiveDate"] = employee.EmployeeSalaryInstructions
              .length
              ? this.getFormattedDate(
                  employee.EmployeeSalaryInstructions[0].effective_date
                )
              : "-";
          }
        }
        this.employeeData = [...this.employeeData];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to format the date */
    getFormattedDate(updated_at) {
      try {
        /** PL_1661 */
        let newFormattedDate =
          this.monthList[new Date(updated_at).getMonth()] +
          " - " +
          new Date(updated_at).getFullYear();
        /** PL_1661 */
        return newFormattedDate;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get the salary status to show in the table */
    getStatus(salaryList) {
      try {
        let statusObj = salaryList.find(item => item.current_status);
        switch (statusObj.current_salary_status) {
          case "hold_salary":
            return "On Hold";
            break;
          case "release":
            return "Active";
            break;
          case "stop_salary":
            return "Stop";
            break;
          case "normal":
            return "Active";
            break;
          default:
            return "Active";
            break;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to filter the data by name */
    // not imlemented yet
    filterData(val) {
      this.searchText = val;
    },

    /* server call to get salary bands */
    async fetchBands() {
      try {
        let res = await this.fetch_bands(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get business units */
    async fetchBunits() {
      try {
        let res = await this.fetch_bunits(this.orgId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get cost centres */
    async fetchCostCentres() {
      try {
        let res = await this.fetch_costcentre(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get locations */
    async fetchLocations() {
      try {
        let res = await this.fetch_loc(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get subcriteria after changing the criteria */
    getSubCriteria(val) {
      try {
        this.formData.subCriteria = "";
        if (val) {
          if (val.name == "Bands") {
            this.fetchBands();
          }
          if (val.name == "Business Unit") {
            this.fetchBunits();
          }
          if (val.name == "Cost Centre") {
            this.fetchCostCentres();
          }
          if (val.name == "Locations") {
            this.fetchLocations();
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to go back to utilities */
    cancel() {
      // PL_1662
      this.$router.push(
        `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
      );
    },

    /* for bulk upload */
    // not imlemented yet
    release() {
      this.showSuccessMsg = true;
    },
    /* function to close popup */
    goBackToLocationPage() {
      this.showSuccessMsg = false;
    },

    /* function to go to hold, releas and stop salary page */
    async gotoRelease(record, type) {
      try {
        await this.act_changeEditMode({ status: type, record: record });
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/release_salary`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.3;
  pointer-events: none;
}

.search {
  padding-right: 20px;
}
.radio {
  display: flex;
  flex-wrap: 10px;
}

.action-section:hover {
  .action-menu {
    display: block;
  }
}
.action-section {
  display: inline-block;
  margin-left: 15px;
  text-align: center;

  img {
    width: auto;
  }

  .action-menu {
    display: none;
    top: 0%;
    left: -170px;
    right: 0;
    width: max-content;
    padding-top: 5px;
    padding-bottom: 5px;
    li {
      padding: 0px;
      font-weight: 500;
      span {
        margin: 0px 20px;
        padding: 10px;
        display: block;
      }
      &:not(:last-child) {
        span {
          border-bottom: solid 1px #979797;
        }
      }
    }
  }
}
.margin-15 {
  margin: 15px 0px 0px 15px;
}

.margin-bottom-100 {
  margin-bottom: 100px;
}
</style>
